import $ from 'jquery';
import {isEqual} from 'lodash';
import Actions from '@ppcp/actions';

let actions = new Actions();

actions.addAction('after_populate_checkout_fields', (controller) => {
    // only proceed if this is the express checkout context
    if (controller.needsShipping() && controller.context.isExpressCheckout()) {
        if ($('[name="bill_to_different_address"]').length > 0) {
            /**
             * If the shipping address differs from the billing address, make sure
             * "different_from_shipping" is selected
             * @type {*|string|jQuery}
             */
            const billingAddress = controller.getCartFullAddress('billing', true);
            const shippingAddress = controller.getCartFullAddress('shipping', true);

            // if the billing and shipping address do not match
            // make sure the "different_from_shipping" option is checked.
            if (!isEqual(billingAddress, shippingAddress)) {
                const value = $('[name="bill_to_different_address"]:checked').val();
                if (value !== 'different_from_shipping') {
                    $('[name="bill_to_different_address"][value="different_from_shipping"]').prop('checked', true);
                }
            }

            //redirect the customer to the #cfw-payment-method step.
            window.location.hash = '#cfw-payment-method';
        }
    }
});

actions.addAction('ppcp_fastlane_payment_tokenized', () => {
    window.location.hash = '#cfw-payment-method';
});